import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { RestClient } from '@elderbyte/ngx-starter'
import { environment } from '../../../environments/environment'
import { ControlTerminal } from './control-terminal'

@Injectable({
  providedIn: 'root',
})
export class ControlTerminalService extends RestClient<ControlTerminal, string> {
  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)

    super(environment.apiPath + '/control-terminals', http, {
      idField: 'controlCenterId',
    })
  }
}
